import { createContext, useContext, type ReactNode } from 'react'

/** Environment stamped on deployment-scoped run reads so caches and APIs stay apart. */
export interface DeploymentRunScopeValue {
  environment?: string
  deploymentId?: string
}

const DeploymentRunScopeContext = createContext<DeploymentRunScopeValue | null>(null)

export function DeploymentRunScopeProvider({
  value,
  children,
}: {
  value: DeploymentRunScopeValue
  children: ReactNode
}) {
  return (
    <DeploymentRunScopeContext.Provider value={value}>
      {children}
    </DeploymentRunScopeContext.Provider>
  )
}

export function useDeploymentRunScope(): DeploymentRunScopeValue | null {
  return useContext(DeploymentRunScopeContext)
}
